<template>
  <div class="glod-list-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-button type="primary" size="small" @click="goldOperation('add')" class="add-input">+新增配置</el-button>
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="multipleTable">
      <el-table-column prop="id" label="ID" align="center" fixed min-width="200">
        <template slot-scope="scope">
          <span>{{scope.row.id || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="基础金币额度" align="center" fixed min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.amount || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="incrAmount" label="优惠额度" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.incrAmount || '0'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="incTax" label="优惠率" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{(scope.row.incTax || '0') | numFormat}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="type" label="支付方式" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{scope.row.type || '0'}}</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="typeName" label="支付类型" align="center" min-width="240">

        <template slot-scope="scope">
          <span>{{scope.row.typeName || '未知'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="120">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="goldOperation('edit',scope.row)"></el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeGold(scope.row.id)"></el-button>
        </template>
      </el-table-column>
    </el-table>

   <!--分页组件-->
    <el-pagination
      :page-sizes="[5,10, 15, 20]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>  
    <!--新增、编辑弹框-->
    <gold-action ref="goldAction" @handlerGoldList="getPayGoldList('status')"></gold-action>
  </div>
</template>

<script>
import API from '@/api'
import GoldAction from "./components/goldAction"
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        amount:'',
        type:'',
        typeName:''
      }      
    }
  },
  components: {
    GoldAction
  },
  created() {
    this.getPayGoldList()
  },
  methods: {
    // 请求金币优惠配置
    getPayGoldList() {
      this.loading = true;
      API.getPayGoldList(this.params).then(res => {
        if (res.code === 200 && res.data.list) {
          this.tableData = res.data.list
          this.total=res.data.total
        } else {
          this.tableData = []
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 删除金币支付配置
    removeGold(id) {
      this.$confirm('您确定要删除当前金币支付配置吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          API.delPayGold({ ids: [id] }).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '删除金币支付配置成功',
                type: 'success'
              })
              this.getPayGoldList()
            } else {
              this.$message.error('删除金币支付配置失败')
            }
          })
        })
        .catch(() => { });
    },
     // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size;
      this.params.pageNumber = 1;
      this.getPayGoldList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getPayGoldList();
    },  
    // 新增、编辑操作
    goldOperation(type, data) {
      this.$refs.goldAction.open(type, data)
    }
  }
}
</script>

<style lang="scss">
.gold-list-box {
  .add-input {
    margin-left: 0 !important;
  }
}
</style>
